import React from "react";

// Substitui o `react-albus`, que está sem manutenção desde 2022 e declara peer
// de React ^15||^16 — ou seja, barra o React 18. Além disso ele usa
// componentWillMount + legacy context e chama setState em fase de render, que é
// justamente o que o StrictMode do React 18 pune.
//
// A API foi mantida igual (<Wizard><Steps><Step render={({next, previous})} />)
// porque é só isso que o projeto usa: nenhum dos dois consumidores toca em
// `WithWizard`, `wizard.push`, `go` ou no history do albus. No albus o
// `previous` era um goBack de um memory history; como os dois wizards daqui são
// lineares e não dão salto, índice-1 é equivalente.

const WizardContext = React.createContext(null);

export function Wizard({ children }) {
  const [index, setIndex] = React.useState(0);
  const value = React.useMemo(() => ({ index, setIndex }), [index]);

  return (
    <WizardContext.Provider value={value}>{children}</WizardContext.Provider>
  );
}

export function Steps({ children }) {
  const context = React.useContext(WizardContext);

  if (!context) {
    throw new Error("<Steps> precisa estar dentro de um <Wizard>.");
  }

  const { index, setIndex } = context;

  // toArray achata o array vindo do .map junto com os <Step> soltos e descarta
  // null/false, que é como os consumidores montam a lista.
  const steps = React.Children.toArray(children);

  if (steps.length === 0) {
    return null;
  }

  // Protege contra a lista encolher depois que o passo já avançou.
  const current = steps[Math.min(index, steps.length - 1)];

  const next = () => setIndex((i) => Math.min(i + 1, steps.length - 1));
  const previous = () => setIndex((i) => Math.max(i - 1, 0));

  return current.props.render({ next, previous });
}

// Marcador: quem renderiza de fato é o <Steps>, que lê o `render` daqui.
export function Step() {
  return null;
}
